import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

export interface ArgentineSessionLimitTemplate {
	activeFrom: string;
	limitValue: number;
	limitPeriod: string;
}

export enum ArgentineSessionLimitPeriod {
	Daily = 1,
	Weekly = 7,
	Monthly = 30,
}

export enum ArgentineSessionLimitSuggestionAmounts {
	Daily = 24,
	Weekly = 168,
	Monthly = 720,
}

export enum ArgentineSessionLimitPeriodTranslationsEnum {
	Daily = "dailySessionLimit",
	Weekly = "weeklySessionLimit",
	Monthly = "monthlySessionLimit",
}

export interface ArgentineSessionLimitFormGroup extends UntypedFormGroup {
	controls: {
		sessionLimitAmount: UntypedFormControl;
		sessionLimitPeriod: UntypedFormControl;
	};
}
